export default {
  forgot_password_confirm: {
    title: 'パスワードリセット',
    required_code: 'コードは必須項目です。',
    required_password: 'パスワードは必須項目です。',
    max_length_16: 'パスワードは８～１６文字でなければなりません。',
    no_blank: '半角英数または記号で入力してください。',
    no_password_match: 'パスワードは一致しません。',
    reset_password: 'パスワード再設定',
    caution: '画面をまだ閉じないでください',
    double_check_text: '@:login.double_check_text',
    password_reset_text: '入力いただいたメールアドレスにお送りしたメール内の確認コードを下記フォームに入力し、新しいパスワードを設定してください。',
    verification_code: '確認コード',
    mail_send_code: 'メールに送ったコード',
    password: 'パスワード',
    new_password: '新しいパスワード',
    password_display: 'パスワードを表示',
    password_no_display: 'パスワードを未表示',
    password_check: '新しいパスワード（確認）',
    submit: '設定する',
  },
}
